import { render } from "./CarListItem.vue?vue&type=template&id=20580b4f&scoped=true"
import script from "./CarListItem.vue?vue&type=script&lang=js"
export * from "./CarListItem.vue?vue&type=script&lang=js"

import "./CarListItem.vue?vue&type=style&index=0&id=20580b4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20580b4f"]])

export default __exports__